import { useState } from "react";
import rightArrowWhite from "../static files/images/right-arrow White.png";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getBlogById } from "../slices/blogReducer";

const ExampleCard = ({ blog }) => {
  const [hovered, setHovered] = useState(false);
  const dispatch=useDispatch();
  const navigate = useNavigate();
  const { blogs, selectedBlog, detailStatus } = useSelector(
    (state) => state.blogs
  );

  return (
    <article
      className="card"
      style={{
        backgroundImage: `
      linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.9)),
      url(${blog.image})
    `,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {!hovered ? (
        <>
          <h2>{blog.title}</h2>
          <h3>
            {blog.about.length > 40
              ? blog.about.substring(0, 40) + "..."
              : blog.about}
          </h3>
        </>
      ) : (
        <div className="blue-box">
          <h2>{blog.title}</h2>
          <h3>
            {blog.about.length > 40
              ? blog.about.substring(0, 40) + "..."
              : blog.about}
          </h3>
          <a
            href="#"
            onClick={() => {
              dispatch(getBlogById(blog._id));
              navigate(`/blog/${blog._id}`);
            }}
          >
            DAHA ÇOX BAX <img src={rightArrowWhite} alt="Tökmə alüminium" />
          </a>
        </div>
      )}
    </article>
  );
};

export default ExampleCard;
